/** @typedef {'no-account'|'not-approved'|'no-brands'} _T0Reason */

/** @typedef {'desktop'|'mobile'} _BadgePlatform */

/** @typedef {'footer'|'header'|'mid'|'island'} _BadgeVariant */

export const badgeVariants = [ 'footer', 'mid', 'header', 'island' ];
export const badgeVariantAlias = {
  'mid': 'sidebar',
  'island': 'content'
};
export const badgeVariantInverseAlias = {
  'sidebar': 'mid',
  'content': 'island'
};

/** @typedef {'free'|'start'|'premium'} _BadgePlan */

/** @typedef {'live'|'test'} _BadgeEnvironment */

/**
 * @typedef {'top'|'middle'|'bottom'|'two_thirds'|'custom'} _BadgeTypeOptions_Position_VerticalLocation
 */

/**
 * @typedef {'left'|'right'|'custom'} _BadgeTypeOptions_Position_HorizontalLocation
 */

/**
 * @typedef _BadgeTypeOptions_Position_VerticalSettings
 * @property {'top'|'bottom'} reference
 * @property {number} distance
 * @property {'px'|'%'|'vh'} unit
 */

/**
 * @typedef _BadgeTypeOptions_Position_HorizontalSettings
 * @property {'left'|'right'} reference
 * @property {number} distance
 * @property {'px'|'%'|'vh'} unit
 */

/**
 * @typedef _BadgeTypeOptions_PositionConfig
 * @property {_BadgeTypeOptions_Position_VerticalLocation} verticalLocation
 * @property {_BadgeTypeOptions_Position_VerticalSettings} [verticalSettings]
 * @property {_BadgeTypeOptions_Position_HorizontalLocation} horizontalLocation
 * @property {_BadgeTypeOptions_Position_HorizontalSettings} [horizontalSettings]
 */

/**
 * @typedef _BadgeTypeOptions
 * @property {string} [targetElementType ='div']
 * @property {number} [zIndex = 2000]
 * @property {boolean} [enabled]
 * @property {_BadgeTypeOptions_PositionConfig} [position]
 */

/**
 @typedef _BadgeType
 @property {_T0Reason} [t0] when set, a t0 badge will be shown
 @property {_BadgePlatform} platform the target platform (e.g. desktop, mobile)
 @property {_BadgeVariant} variant the badge type variant (e.g header, mid, ...)
 @property {_BadgePlan} plan the target plan of the badge (taken into account for rendering)
 @property {_BadgeEnvironment} environment
 @property {_Language} [language] the language of the badge
 @property {_BadgeTypeOptions} [options] other badge options
 @property {_BadgePlan} [originalPlan] the original plan of the badge (kept for traceability, e.g. when fallback or promotion occurs)
 */
